<template>
  <div class="column-box">
    <slot name="header"></slot>
    <div
      v-for="(item, index) in list"
      :key="'column_content_' + index"
      :class="[{ 'alone': item.alone },'column_content_mrbtm']"
    >
      <div
        class="column-title"
      >
        {{ item[paramsOpt.value] }}{{ separator || columnSeparator }}
      </div>
      <template v-if="item.toolTip">
        <el-popover
          placement="top-start"
          trigger="hover"
          :content="item.toolTip.content"
        >
          <span slot="reference">
            <i
              :class="[
                 item.toolTip.iconClass || 'el-icon-info',
              ]"
              class="toolTip"
            ></i>
          </span>
        </el-popover>
      </template>
      <div class="column-cont">
        <!-- 是否按千分符格式展示 -->
        <span v-if="item.finance">
          <span
            v-thousand-separator="getCont(item)"
          >
          </span>
          元
        </span>
        <span v-else-if="item.formatter">{{ customNode(item) }}</span>
        <span v-else>
         {{ getCont(item) }}
        </span>
        <template
          v-if="
            item.viewBtn &&
            (item.viewBtn.showFn && item.viewBtn.showFn())
          "
        >
          <el-button
            :loading="item.viewBtn.loading"
            style="margin-left: 50px"
            :type="item.viewBtn.type || 'primary'"
            @click="item.viewBtn.clickFn && item.viewBtn.clickFn(item)"
            >{{ item.viewBtn.label || "查看" }}</el-button
          >
        </template>
      </div>
    </div>
    <slot name="default"></slot>
  </div>
</template>

<script>
export default {
  name: 'ColumnBox',
  props: {
    column: {
      type: [String, Number],
      default: 3,
      validator(prop) {
        if (prop < 1) return false
        return prop % 1 === 0
      },
    },
    source: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
    labelWidth: {
      type: [Number, String],
      default: '',
    },
    separator: {
      type: String,
      default: '',
    },
    paramsOpt: {
      type: Object,
      default: () => ({
        key: 'key',
        value: 'name',
      }),
    },
  },
  methods: {
    getCont(item) {
      const keys = item && this.paramsOpt.key && item[this.paramsOpt.key] && item[this.paramsOpt.key].split('.')
      let value = this.source
      for (const key of keys) {
        value = value && value[key]
      }
      if (value !== null && value !== undefined && item.unit) {
        value += item.unit
      }
      return value || '--'
    },
    customNode(item) {
      let value = this.getCont(item)
      if (value === '--') value = undefined
      return item.formatter && item.formatter(value)
    },
  },
  mounted() {
    this.$nextTick(() => {
      const box = this.$el
      const width = box.getBoundingClientRect().width - 8
      box.childNodes.forEach((div) => {
        if ((div.nodeType === 1) && (div.className.indexOf('alone') === -1)) {
          div.style.width = `${(width - 50) / this.column}px` // 减50是为了防止 childWidth * column > width
        }
      })
      box.querySelectorAll('.column-title').forEach((div) => {
        const w = String(this.labelWidth)
        div.style.width = w + (w.endsWith('px') ? '' : 'px')
      })
    })
  },
}
</script>

<style lang="less" scoped>
.column-box {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  box-sizing: content-box !important;
  & > * {
    display: flex;
    line-height: 20px;
    margin-bottom: 23px;
    word-break: break-all;

    > .column-title {
      text-align: right;
      padding-right: 10px;
      color: #333333;
    }

    > .column-cont {
      display: flex;
      align-items: flex-start;
      flex: 1;
      color: #666;
    }
  }

  & > *.alone {
    width: 100% !important;
  }
}
</style>
